import React, { useEffect } from 'react';

export function useClickOutside<T extends HTMLElement>(
  ref: React.RefObject<T | null>,
  handler: () => void
) {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }
      handler();
    };

    // Use passive listeners for better performance
    // document.addEventListener('mousedown', listener, { passive: true });
    // document.addEventListener('touchstart', listener, { passive: true });
    document.addEventListener('click', listener, { passive: true });

    return () => {
      // document.removeEventListener('mousedown', listener);
      // document.removeEventListener('touchstart', listener);
      document.removeEventListener('click', listener);
    };
  }, [ref, handler]);
}
